module.exports = __webpack_public_path__ + "static/media/ant1.f2e90800.png";